import { storeItem, getStoredItem, flushStorage } from "@cayuse/shared-react.utils.app-storage";

import {
	STORAGE_AWARD_ACTIVE_COLS,
	STORAGE_MODIFICATIONS_ACTIVE_COLS,
	STORAGE_AWARDS_CONTENT,
	STORAGE_PROJECT_ACTIVE_COLS,
	STORAGE_PROPOSAL_ACTIVE_COLS,
	STORAGE_FORM_STATUS,
	STORAGE_PROPOSALS_CONTENT,
	STORAGE_SHELL_CONTENT,
	STORAGE_SUBAWARD_ACTIVE_COLS,
	WEEK_IN_MILLISECONDS,
	STORAGE_FEED_JOBS_JOB_ID,
	STORAGE_SUBAWARDS_CONTENT,
	STORAGE_TASK_ACTIVE_COLS,
	STORAGE_SUBAWARDS_MODIFICATIONS_ACTIVE_COLS,
	STORAGE_FACETED_SEARCH
} from "globals/constants";

export { storeItem, getStoredItem, flushStorage };

export const storeShellContent = content => {
	content.cayuseHeader = {
		product: "SP",
		host: null,
		userId: null,
		authenticationToken: null
	};

	storeItem(STORAGE_SHELL_CONTENT, content, sessionStorage);
};

export const getStoredShellContent = () => {
	return getStoredItem(STORAGE_SHELL_CONTENT, sessionStorage);
};

export const storeProposalsContent = content => {
	return storeItem(STORAGE_PROPOSALS_CONTENT, content);
};

export const getStoredProposalsContent = () => {
	return getStoredItem(STORAGE_PROPOSALS_CONTENT);
};

export const storeProposalActiveColumns = columns => {
	storeItem(STORAGE_PROPOSAL_ACTIVE_COLS, columns, sessionStorage);
};

export const getStoredProposalActiveColumns = () => {
	return (getStoredItem(STORAGE_PROPOSAL_ACTIVE_COLS, sessionStorage) ?? []).filter(Boolean);
};

export const storeProjectActiveColumns = columns => {
	return storeItem(STORAGE_PROJECT_ACTIVE_COLS, columns, sessionStorage);
};

export const getStoredProjectActiveColumns = () => {
	return (getStoredItem(STORAGE_PROJECT_ACTIVE_COLS, sessionStorage) ?? []).filter(Boolean);
};

export const storeFormStatus = (formId, status) => {
	const storedProposalFormStatuses = getStoredItem(STORAGE_FORM_STATUS, localStorage) || {};
	const cleanedData = Object
		.keys(storedProposalFormStatuses)
		.reduce((response, currentValue) => {
			if (storedProposalFormStatuses[currentValue].expires >= (Date.now() - WEEK_IN_MILLISECONDS)) {
				response[currentValue] = storedProposalFormStatuses[currentValue];
			}

			return response;
		}, {});

	cleanedData[formId] = { data: status, expires: Date.now() + WEEK_IN_MILLISECONDS };

	storeItem(STORAGE_FORM_STATUS, cleanedData, localStorage);
};

export const getStoredFormStatus = formId => {
	const storedFormStatuses = getStoredItem(STORAGE_FORM_STATUS, localStorage) || {};

	return storedFormStatuses[formId]?.data || [];
};

export const storeAwardsContent = content => {
	return storeItem(STORAGE_AWARDS_CONTENT, content);
};

export const getStoredAwardsContent = () => {
	return getStoredItem(STORAGE_AWARDS_CONTENT);
};

export const storeAwardsActiveColumns = columns => {
	storeItem(STORAGE_AWARD_ACTIVE_COLS, columns, sessionStorage);
};

export const getStoredAwardsActiveColumns = () => {
	return (getStoredItem(STORAGE_AWARD_ACTIVE_COLS, sessionStorage) ?? []).filter(Boolean);
};

export const storeModificationsActiveColumns = columns => {
	storeItem(STORAGE_MODIFICATIONS_ACTIVE_COLS, columns, sessionStorage);
};

export const getStoredModificationsActiveColumns = () => {
	return (getStoredItem(STORAGE_MODIFICATIONS_ACTIVE_COLS, sessionStorage) ?? []).filter(Boolean);
};

export const storeSubawardModificationsActiveColumns = columns => {
	storeItem(STORAGE_SUBAWARDS_MODIFICATIONS_ACTIVE_COLS, columns, sessionStorage);
};

export const getSubawardModificationsActiveColumns = () => {
	return (getStoredItem(STORAGE_SUBAWARDS_MODIFICATIONS_ACTIVE_COLS, sessionStorage) ?? []).filter(Boolean);
};

export const storeSubawardsContent = content => {
	return storeItem(STORAGE_SUBAWARDS_CONTENT, content);
};

export const getStoredSubawardsContent = () => {
	return getStoredItem(STORAGE_SUBAWARDS_CONTENT);
};

export const storeSubawardsActiveColumns = columns => {
	storeItem(STORAGE_SUBAWARD_ACTIVE_COLS, columns, sessionStorage);
};

export const getStoredSubawardsActiveColumns = () => {
	return (getStoredItem(STORAGE_SUBAWARD_ACTIVE_COLS, sessionStorage) ?? []).filter(Boolean);
};

export const storeTasksActiveColumns = columns => {
	storeItem(STORAGE_TASK_ACTIVE_COLS, columns, localStorage);
};

export const getStoredTasksActiveColumns = () => {
	return (getStoredItem(STORAGE_TASK_ACTIVE_COLS, localStorage) ?? []).filter(Boolean);
};

export const storeFeedJobId = jobId => {
	return storeItem(STORAGE_FEED_JOBS_JOB_ID, jobId, localStorage);
};

export const getStoredFeedJobId = () => {
	return getStoredItem(STORAGE_FEED_JOBS_JOB_ID, localStorage);
};

export const storeFacetedSearch = (type, id, value) => {
	return storeItem(`${STORAGE_FACETED_SEARCH}_${type}_${id}`, value, localStorage);
};

export const getStoredFacetedSearch = (type, id) => {
	return getStoredItem(`${STORAGE_FACETED_SEARCH}_${type}_${id}`, localStorage);
};
